import { Link } from "react-router-dom";
import { NavigationProps } from "../../interfaces/navigationLink.interface";

const NavgigationLink = ({ to, children, ...props }: NavigationProps) => {
  return (
    <Link
      to={to}
      className=" rounded-[32px] no-underline bg-primary text-white py-[5px] px-[11px] h-max"
      {...props}
    >
      {children}
    </Link>
  );
};

export default NavgigationLink;
